import { render, staticRenderFns } from "./QuizAnswers.vue?vue&type=template&id=1734d2b4&scoped=true&"
import script from "./QuizAnswers.vue?vue&type=script&lang=js&"
export * from "./QuizAnswers.vue?vue&type=script&lang=js&"
import style0 from "./QuizAnswers.vue?vue&type=style&index=0&id=1734d2b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1734d2b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
